import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'documentReviewKPI';

const initialState = {
    criteria: {},
    managerKPIs: [],
    reviewerKPIs: [],
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setManagerKPIs(state, action) {
            state.managerKPIs = json.toJSON(action.payload);
        },
        setReviewerKPIs(state, action) {
            state.reviewerKPIs = json.toJSON(action.payload);
        }
    }
})

export const { setCriteria, setManagerKPIs, setReviewerKPIs } = slice.actions;
export const { reducer } = slice;

export const selectCriteria = state => state[name].criteria;
export const selectManagerKPIs = state => json.fromJSON(state[name].managerKPIs);
export const selectReviewerKPIs = state => json.fromJSON(state[name].reviewerKPIs);

const documentReviewKPIReducer = reducer;
export default documentReviewKPIReducer;